/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxGamesIntegrationOneStoreOneStoreMarketClassificationFromJSON, FxGamesIntegrationOneStoreOneStoreMarketClassificationToJSON, } from './FxGamesIntegrationOneStoreOneStoreMarketClassification';
/**
 * Check if a given object implements the FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData interface.
 */
export function instanceOfFxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData(value) {
    if (!('Token' in value) || value['Token'] === undefined)
        return false;
    if (!('DeveloperPayload' in value) || value['DeveloperPayload'] === undefined)
        return false;
    if (!('Sku' in value) || value['Sku'] === undefined)
        return false;
    if (!('MarketClassification' in value) || value['MarketClassification'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataFromJSON(json) {
    return FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataFromJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Token': json['Token'],
        'DeveloperPayload': json['DeveloperPayload'],
        'Sku': json['Sku'],
        'MarketClassification': FxGamesIntegrationOneStoreOneStoreMarketClassificationFromJSON(json['MarketClassification']),
    };
}
export function FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataToJSON(json) {
    return FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataToJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Token': value['Token'],
        'DeveloperPayload': value['DeveloperPayload'],
        'Sku': value['Sku'],
        'MarketClassification': FxGamesIntegrationOneStoreOneStoreMarketClassificationToJSON(value['MarketClassification']),
    };
}
//# sourceMappingURL=FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData.js.map